<template>
	<div class="leaveContainer">
		<ul class="leaveConent">
			<li><el-input placeholder="姓名" v-model="name" clearable></el-input></li>
			<li><el-input placeholder="手机号码" v-model="phone" clearable></el-input></li>
			<li><el-input placeholder="邮箱地址" v-model="mail" clearable></el-input></li>
			<li><el-input placeholder="公司名称" v-model="business" clearable></el-input></li>
			<li><el-input placeholder="职位" v-model="position" clearable></el-input></li>
			<li>
				<el-select v-model="value" placeholder="我要加盟">
					<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
				</el-select>
				<!-- <el-input placeholder="我要加盟" v-model="join" clearable></el-input> -->
			</li>
		</ul>
		<el-input :autosize="{ minRows: 8, maxRows: 12 }" type="textarea" :rows="2" placeholder="留言" v-model="textarea"></el-input>
	</div>
</template>

<script>
export default {
	data() {
		return {
			name: '',
			phone: '',
			mail: '',
			business: '',
			position: '',
			// join: '',
			textarea: '',
			options: [
				{
					value: '选项1',
					label: '我要加盟'
				}
			],
			value: ''
		};
	}
};
</script>

<style>
.leaveContainer {
	/* background: #fff; */
}
.leaveContainer .leaveConent {
	display: flex;
	justify-content: space-between;
	flex-wrap: wrap;
	/* border:1px solid red; */
}
.leaveContainer .leaveConent > li {
	width: 29%;
	font-size: 20px;
	display: flex;
	justify-content: space-between;
	/* border: 1px solid #848484; */
	color: #848484;
	margin-bottom: 30px;
	border-radius: 6px;
	/* overflow: hidden; */
}
.leaveContainer .leaveConent > li > span {
	color: red;
}
.leaveContainer .leaveConent > li > input {
	height: 94%;
	line-height: 94%;
	width: 90%;
	outline: none;
	border: none;
	font-size: 18px;
}
.el-input, .el-select{
	width: 100%;
}
input{
	height: 44px!important;
}
</style>
